import { capitalize } from 'lodash';

import { Accessory } from '../accessories/accessories.types';
import { Battery } from '../batteries/batteries.types';
import { Charger } from '../chargers/chargers.types';
import { Consumable } from '../consumables/consumables.types';
import { Device } from '../devices/devices.types';
import { GlobalSettings } from '../global-settings/global-settings.types';
import { HardDrive } from '../hard-drives/hard-drives.types';
import { PurchaseItem } from '../purchases/purchases.types';
import { Ram } from '../rams/rams.types';
import { UserCompanyRole } from '../users/users.types';

class DicoLabelsService {
  getStateLabel(key: string): string {
    if (key === 'ongoing') return 'En cours';
    if (key === 'full') return 'Pleine';
    if (key === 'picked') return 'Ramassée';
  }

  getCollectionLabel(key: string, alt?: 'short' | 'long'): string {
    if (key === 'MacBookcase') return 'Coque';
    if (key === 'MacBookscreen') return 'Vitre / Dalle';
    if (key === 'MacBooktopcase') return 'Chassis';
    if (key === 'Mactopcase') return 'Boitier metal';
    if (key === 'iPadcase') return 'Coque';
    if (key === 'iPadscreen') return 'Vitre / Dalle';
    if (key === 'accessory_part_id') return "ID de l'accessoire ou de la pièce détachée";
    if (key === 'accessory_problems') return 'Problèmes chargeurs';
    if (key === 'adjust_hinge') return 'Ajustement Charnière';
    if (key === 'alias_rules') return "Règles d'aliassage";
    if (key === 'amount') return 'Montant';
    if (key === 'amount_ht') return 'Montant HT';
    if (key === 'amount_sub_type') return 'Sous-type';
    if (key === 'amount_ttc') return 'Montant TTC';
    if (key === 'amount_type') return 'Type';
    if (key === 'analysis_supplier_file') return 'Fichier fournisseur analysable';
    if (key === 'annee_modele') return 'Année-modèle';
    if (key === 'auto_apple') return 'Auto-réparation Apple';
    if (key === 'apple_refs') return 'ID Apple';
    if (key === 'apple_spot') return 'Halo pomme';
    if (key === 'aspiring_grade') return 'Nouv. Grade';
    if (key === 'at_reception') return 'A la livraison';
    if (key === 'battery_ratio') return 'Ratio batterie';
    if (key === 'battery_ratio' && alt === 'long') return 'Ratio batterie';
    if (key === 'battery_ratio' && alt === 'short') return 'Ratio batterie';
    if (key === 'before_reception') return 'Avant expédition';
    if (key === 'bezel') return 'Bezel';
    if (key === 'bic') return 'Code BIC';
    if (key === 'blue_spots') return 'Tâches bleu';
    if (key === 'booked_btob') return 'Réservé BtoB';
    if (key === 'booked_marketing') return 'Réservé Marketing';
    if (key === 'bottom') return 'Bottom';
    if (key === 'brand_new_box') return 'Boîte neuve';
    if (key === 'broken') return 'Écran cassée / fêlée';
    if (key === 'screen_broken') return 'Écran cassée / fêlée';
    if (key === 'buffer_alert') return 'Alerte stock tampon';
    if (key === 'battery') return 'Batterie';
    if (key === 'cage') return 'Cage';
    if (key === 'cage_number') return 'Numéro de cage';
    if (key === 'carrier') return 'Transporteur';
    if (key === 'cart_number') return '# chariot';
    if (key === 'cart_type') return 'Type de chariot';
    if (key === 'case_grade') return 'Grade coque';
    if (key === 'case_twisted') return 'Chassis tordue';
    if (key === 'category') return 'Catégorie';
    if (key === 'charger_included') return 'Présence du chargeur';
    if (key === 'chargers') return 'Chargeurs';
    if (key === 'check_ref_supplier') return 'Référence fournisseur';
    if (key === 'city') return 'Ville';
    if (key === 'clean') return 'Nettoyage';
    if (key === 'clean_control') return 'Nettoyage';
    if (key === 'clean_prod') return 'Nettoyage';
    /* Tâches CONF (préparation avant expédition), libellés courts */
    if (key === 'clean_connectors') return 'Nettoyage connectiques';
    if (key === 'clean_keyboard') return 'Nettoyage clavier';
    if (key === 'clean_mouse_check_cable') return 'Nettoyage souris / câble';
    if (key === 'clean_screen') return 'Nettoyage écran';
    if (key === 'clean_blowing') return 'Soufflage';
    if (key === 'send_guaranty') return 'Pastille de garantie';
    if (key === 'send_cleaning') return 'Nettoyage succinct';
    if (key === 'send_charger') return 'Chargeur';
    if (key === 'send_charger_uk') return 'Plug UK';
    if (key === 'send_charger_pouch') return 'Pochette chargeur';
    if (key === 'send_flyer') return 'Flyer';
    if (key === 'send_goodies') return 'Goodies';
    if (key === 'send_gift_card') return 'Carte cadeau';
    if (key === 'send_userguide') return 'Manuel';
    if (key === 'send_leaflet') return 'Dépliant';
    if (key === 'send_extension_cord') return 'Rallonge';
    if (key === 'send_cleaning_cloth') return 'Chiffonnette';
    if (key === 'send_camera_cover') return 'Cache caméra';
    if (key === 'send_thread_by_thread') return 'Fil à fil';
    if (key === 'packaging') return 'Papier bulles';
    if (key === 'on_trolley') return 'Chariot stock';
    if (key === 'pairing_keyboard') return 'Appairage clavier';
    if (key === 'pairing_mouse') return 'Appairage souris';
    if (key === 'quality_step') return 'Vérification qualité';
    if (key === 'cliker') return 'Cliker';
    if (key === 'code') return 'Code interne Okamac';
    if (key === 'color') return 'Couleur';
    if (key === 'comment') return 'Commentaire';
    if (key === 'comment-purchase-creation') return 'Création de la commande';
    if (key === 'comment-purchase-depause') return 'Dernière annulation de la pause';
    if (key === 'comment-purchase-pause') return 'Dernière mise en pause';
    if (key === 'company') return 'Société';
    if (key === 'compatibility_ecran') return 'Compatibilty';
    if (key === 'computer_quantity') return "Nombre d'ordinateurs";
    if (key === 'computer_type') return "Type d'ordinateurs";
    if (key === 'consumable_types') return "Types d'emballage";
    if (key === 'consumables_mix') return "Types d'emballages";
    if (key === 'control_started_at') return 'Contrôle débuté le';
    if (key === 'control_started_by') return 'Contrôle débuté par';
    if (key === 'control_terminated_at') return 'Contrôle terminé le';
    if (key === 'control_terminated_by') return 'Contrôle terminé par';
    if (key === 'country') return 'Pays';
    if (key === 'country_code') return 'Pays';
    if (key === 'created') return 'Date du pricing';
    if (key === 'created_at' && alt === 'long') return 'Date de chargement';
    if (key === 'created_at') return 'Date de chargement';
    if (key === 'credit_amount') return 'Total des notes de crédit';
    if (key === 'currency') return 'Devise';
    if (key === 'current_battery_capacity') return 'Capacité actuelle';
    if (key === 'initial_battery_capacity') return 'Capacité max';
    if (key === 'customer') return 'Client';
    if (key === 'customer_country') return 'Pays';
    if (key === 'customer_name') return 'Client';
    if (key === 'customer_account_present') return 'Compte du client present (iCloud / Gmail)';
    if (key === 'customer_return_date') return 'Date de demande du client';
    if (key === 'customer_slip') return 'Bordereau client';
    if (key === 'customer_type') return 'Type de client';
    if (key === 'negative_balance') return 'Solde négatif';
    if (key === 'total_revenue') return "Chiffre d'affaires";
    if (key === 'overdue_invoice') return 'Facture en retard';
    if (key === 'cycles' && alt === 'long') return 'Cycles de batterie';
    if (key === 'cycles' && alt === 'short') return 'Cycles';
    if (key === 'date') return 'Date';
    if (key === 'date_reception') return 'Réceptionné le';
    if (key === 'daughterboard') return 'Carte fille';
    if (key === 'deep') return 'Sévère';
    if (key === 'deep_default') return 'Défaut sévère';
    if (key === 'deep_default_front') return 'Défaut sévère - face avant';
    if (key === 'deep_default_inner') return 'Défaut sévère - zone écran';
    if (key === 'deep_default_outer') return 'Défaut sévère - hors zone écran';
    if (key === 'deep_poc') return 'POC sévère';
    if (key === 'deep_scratches') return 'Éraflures profondes';
    if (key === 'deep_stripes') return 'Rayures profondes';
    if (key === 'default') return 'Défauts';
    if (key === 'inner') return 'Zone écran';
    if (key === 'outer') return 'Hors zone écran';
    if (key === 'degraded') return 'Leger';
    if (key === 'destination') return 'Destination';
    if (key === 'ps_delaminated') return 'Délaminage (PS)';
    if (key === 'delaminated') return 'Délaminage';
    if (key === 'delay') return 'A X jours';
    if (key === 'delivery_expected_date') return 'Date de livraison estimée';
    if (key === 'desc') return 'Description';
    if (key === 'desc' && alt === 'long') return 'Référence détaillée';
    if (key === 'device_count') return "Nombre d'ordinateurs";
    if (key === 'device_id' && alt === 'long') return 'Ordinateur associé';
    if (key === 'device_id' && alt === 'short') return 'Ordinateur';
    if (key === 'devices_count') return 'Quantité totale';
    if (key === 'devices_count_a') return 'A';
    if (key === 'devices_count_aa') return 'A+';
    if (key === 'devices_count_b') return 'B';
    if (key === 'devices_count_c') return 'C';
    if (key === 'devices_in_match_stock') return 'Ordinateurs en stock à vendre';
    if (key === 'devices_mix') return "Modèles d'ordinateurs";
    if (key === 'diagnosis') return 'Diagnostique';
    if (key === 'dial_code') return 'Indicateur';
    if (key === 'discoloration') return 'Décoloration';
    if (key === 'visibility_edge_discoloration') return 'Décoloration à la limite du visible';
    if (key === 'light_discoloration') return 'Décoloration léger';
    if (key === 'deep_discoloration') return 'Décoloration sévère';
    if (key === 'discount') return 'Remise';
    if (key === 'display_name') return 'Nom';
    if (key === 'display_order_line') return 'Ligne de commande';
    if (key === 'dust_screen') return 'Poussière écran';
    if (key === 'eligible_polarizer') return 'Éligible filtre';
    if (key === 'eligible_seals') return 'Éligible joints';
    if (key === 'email') return 'Email';
    if (key === 'end_date') return 'Date de fin';
    if (key === 'engraving') return 'Gravure';
    if (key === 'error') return 'Erreur';
    if (key === 'expected_delivery_date') return 'Date de livraison prévue';
    if (key === 'expedition_status') return "Statut d'éxpédition";
    if (key === 'export_type') return "Type d'export";
    if (key === 'extract_battery') return 'Extraction batterie';
    if (key === 'extract_motherboard') return 'Extraction carte mère';
    if (key === 'express') return 'Commande 24h/72h';
    if (key === 'is_bundle') return 'Commande Bundle';
    if (key === 'faulty') return 'Composants défectueux';
    if (key === 'fan') return 'Ventilateur';
    if (key === 'file') return 'Fichier fournisseur initial';
    if (key === 'files_type') return 'Type de fichier';
    if (key === 'ps_filter') return 'Filtre (PS)';
    if (key === 'filter') return 'Filtre';
    if (key === 'filess') return 'Nom du fichier';
    if (key === 'firmware_password') return 'Mot de passe du programme interne present (MacBook)';
    if (key === 'first_name') return 'Prénom';
    if (key === 'fixed_amount') return 'Montant fixe';
    if (key === 'foot') return 'Pied tordu';
    if (key === 'freq') return 'Fréquence du processeur';
    if (key === 'frequence' && alt === 'short') return 'Freq';
    if (key === 'from_shippy') return 'Utilise shippy ?';
    if (key === 'front') return 'Défauts avant';
    if (key === 'grade') return 'Grade';
    if (key === 'grades') return 'Grades';
    if (key === 'graphic_card') return 'Carte Graphique';
    if (key === 'hard_disk') return 'Disque dur';
    if (key === 'has_location') return 'Est dans un emplacement ?';
    if (key === 'hdsize' && alt === 'long') return 'Taille du disque dur (Go)';
    if (key === 'hdsize' && alt === 'short') return 'HD (Taille en Go)';
    if (key === 'hdsize') return 'Taille du disque dur';
    if (key === 'hdtype' && alt === 'long') return 'Type du disque dur';
    if (key === 'hdtype' && alt === 'short') return 'HD (Type)';
    if (key === 'hinge') return 'Charnière';
    if (key === 'idTemp') return 'Étiquette de liste';
    if (key === 'iMacscreen') return 'Vitre / Dalle';
    if (key === 'iMactopcase') return 'Pied';
    if (key === 'iban') return 'Code IBAN';
    if (key === 'id_missing') return "Piece d'identite manquante";
    if (key === 'id_okamac') return 'Code interne Okamac';
    if (key === 'incoterm') return 'INCOTERM';
    if (key === 'initial_comment') return 'Commentaire de Contrôle';
    if (key === 'initial_supplier_file') return 'Fichier fournisseur initial';
    if (key === 'invoice_number' && alt === 'long') return 'Numéro de facture';
    if (key === 'invoice_number' && alt === 'short') return 'N° de facture';
    if (key === 'invoice_ref') return 'Numéro de devis / commande / facture';
    if (key === 'install') return 'Installation';
    if (key === 'is_eligible_painting') return 'Éligible peinture';
    if (key === 'is_exchanged' || key === 'exchanged') return alt === 'short' ? 'Echangée' : 'Commande échangée';
    if (key === 'is_favorite') return 'Favori';
    if (key === 'is_mirakl') return 'Est une Mirakl ?';
    if (key === 'is_paid') return 'Payé ?';
    if (key === 'is_retracted' && alt === 'long') return 'Commande rétractée';
    if (key === 'is_retracted' && alt === 'short') return 'Rétractée';
    if (key === 'is_urgent') return 'Urgent';
    if (key === 'item_type') return 'Type de produits';
    if (key === 'items_mix') return 'Types de produits';
    if (key === 'iteration') return 'Occurences';
    if (key === 'keys') return 'Traces touches';
    if (key === 'visibility_edge_keys') return 'Traces touches à la limite du visible';
    if (key === 'light_keys') return 'Traces touches léger';
    if (key === 'unsellable_keys') return 'Traces touches invendable';
    if (key === 'keyboard' && alt === 'long') return 'Clavier';
    if (key === 'keyboard' && alt === 'short') return 'Clavier';
    if (key === 'keyboard') return 'Clavier';
    if (key === 'keyboard_us') return 'Clavier US';
    if (key === 'cellular') return 'Cellulaire';
    if (key === 'label-update-status') return "Template de relocalisation d'ordinateur de masse";
    if (key === 'last_name' && alt === 'long') return 'Nom de famille';
    if (key === 'last_name' && alt === 'short') return 'Nom';
    if (key === 'last_reception_at' && alt === 'long') return 'Date de livraison réelle';
    if (key === 'left_speaker') return 'Haut parleur droit';
    if (key === 'light') return 'Léger';
    if (key === 'light_default') return 'Défaut léger';
    if (key === 'light_default_front') return 'Défaut léger - face avant';
    if (key === 'light_default_inner') return 'Défaut léger - zone écran';
    if (key === 'light_default_outer') return 'Défaut léger - hors zone écran';
    if (key === 'light_default_off') return 'Défauts légers - Hors écran';
    if (key === 'light_default_on') return 'Défauts légers - Sur écran';
    if (key === 'light_leakage') return 'Fuite de lumière';
    if (key === 'light_poc') return 'POC léger';
    if (key === 'light_scratches') return 'Éraflures légères';
    if (key === 'light_stripes') return 'Rayures légères';
    if (key === 'liquid_spots') return 'Tâche liquide';
    if (key === 'litigation_reasons') return 'Litiges';
    if (key === 'link_type') return 'Type';
    if (key === 'location_name') return 'Emplacement';
    if (key === 'manual_tracking_number') return 'N° de suivi manuel';
    if (key === 'marketplace') return 'Place de marché';
    if (key === 'marketplace_customer_id') return 'Identifiant client';
    if (key === 'marketplace_line_id') return 'Numéro de ligne';
    if (key === 'marketplace_order_id') return 'Numéro de commande';
    if (key === 'marketplace_order_line_id') return 'SKU PDM';
    if (key === 'marketplace_skus_file') return 'Catalogue SKU';
    if (key === 'id') return 'Identifiant';
    if (key === 'location_batch_withdrawal') return 'Liste de numéros de séries';
    if (key === 'marketplace_skus_price_file') return 'Fichier des prix';
    if (key === 'max_shipping_date' && alt === 'long') return "Date max. d'expédition";
    if (key === 'max_shipping_date' && alt === 'short') return "Date max. d'exp.";
    if (key === 'middle') return 'Moyen';
    if (key === 'min_battery_ratio') return 'Ratio de batterie minimum';
    if (key === 'min_grade') return 'Grade minimum';
    if (key === 'miss_foot') return 'Pied manquant';
    if (key === 'mdm_status') return 'Statut MDM active (MacBook)';
    if (key === 'model' && alt === 'long') return "Modèle de l'ordinateur";
    if (key === 'model' && alt === 'short') return 'Modèle';
    if (key === 'model_identifier') return 'Id du modèle';
    if (key === 'model_namestring' && alt === 'long') return 'Nom du modèle';
    if (key === 'model_namestring' && alt === 'short') return 'Modèle';
    if (key === 'model_string') return 'Modèle';
    if (key === 'modeles') return 'Modèles';
    if (key === 'models' && alt === 'long') return 'Références ordinateurs';
    if (key === 'models' && alt === 'short') return 'Modèles';
    if (key === 'motherboard') return 'Carte mère';
    if (key === 'parcel_damaged') return 'Colis endommage';
    if (key === 'parcel_empty') return 'Colis vide';
    if (key === 'parcel_not_received') return 'Colis non recu';
    if (key === 'power_supply') return "Boitier d'Alimentation";
    if (key === 'name') return 'Nom';
    if (key === 'non_buyback_item') return 'Produit insolite recu';
    if (key === 'nappe_battery') return 'Nappe batterie';
    if (key === 'nappe_daughterboard') return 'Nappe carte fille';
    if (key === 'nappe_keyboard') return 'Nappe clavier';
    if (key === 'nappe_touchbar') return 'Nappe touchbar';
    if (key === 'nappe_trackpad') return 'Nappe trackpad';
    if (key === 'nappe_screen') return 'Nappe écran';
    if (key === 'nappe_sound_card') return 'Nappe carte son';
    if (key === 'nappe_jack') return 'Nappe jack';
    if (key === 'nb_expected_packaging') return 'Nb palettes Total';
    if (key === 'nb_items') return "Nombre d'éléments";
    if (key === 'nb_lines') return 'Nb lignes';
    if (key === 'nb_received_packaging' && alt === 'long') return 'Quantité de palettes reçu';
    if (key === 'nb_received_packaging' && alt === 'short') return 'Palettes arrivées';
    if (key === 'new_battery_price' && alt === 'long') return 'Montant batterie neuve';
    if (key === 'new_battery_required' && alt === 'long') return 'Option batterie neuve';
    if (key === 'new_match_required' && alt === 'long') return 'Nouvelle association nécessaire';
    if (key === 'new_match_required' && alt === 'short') return 'Nouvelle asso. nécessaire';
    if (key === 'new_sku') return 'Nouveau SKU';
    if (key === 'nif_code') return 'Code NIF';
    if (key === 'number_cores') return 'Nb de coeurs';
    if (key === 'odoo_part_ref') return 'Référence Odoo de la pièce';
    if (key === 'off') return 'Défauts hors écran';
    if (key === 'on') return 'Défauts sur écran';
    if (key === 'opportunity_name') return "N° d'opportunité";
    if (key === 'order_date') return 'Date de commande';
    if (key === 'order_id' && alt === 'long') return 'Commande associée';
    if (key === 'order_id' && alt === 'short') return 'Commande';
    if (key === 'order_line_type') return 'Type de commande';
    if (key === 'order_returns_nb') return 'Nombre de retours du SN';
    if (key === 'ordered_item_desc') return 'Description';
    if (key === 'ordered_item_namestring') return 'Objet commandé';
    if (key === 'ordered_keyboard') return 'Clavier commandé';
    if (key === 'ordered_mouse') return 'Souris commandée';
    if (key === 'ordered_os') return 'Os commandé';
    if (key === 'ordered_size') return "Taille d'écran";
    if (key === 'ordered_year') return "Année de l'ordinateur";
    if (key === 'orders_file') return 'Fichier de commandes';
    if (key === 'os') return 'OS';
    if (key === 'install_dfu') return 'DFU';
    if (key === 'other_desc') return 'Référence détaillée';
    if (key === 'other_link') return 'Lien internet du produit';
    if (key === 'other_price') return "Prix d'achat";
    if (key === 'other_reason') return "Justification de l'achat (produit et quantité)";
    if (key === 'out_of_stock') return 'Hors stock';
    if (key === 'out_of_stock_proposal') return 'Réservation RC';
    if (key === 'packing') return 'Emballage';
    if (key === 'packaging_photo_file') return "Photo de l'emballage";
    if (key === 'part_type') return 'Type de pièce';
    if (key === 'parts_code') return 'Pièce à changer';
    if (key === 'part_type') return 'Type de pièce';
    if (key === 'paused') return 'En pause';
    if (key === 'paused_at') return 'Mise en pause le';
    if (key === 'paused_by') return 'Mise en pause par';
    if (key === 'payment_confirmation_file') return 'Confirmation du paiement';
    if (key === 'credit_note') return 'Avoir NC';
    if (key === 'payment_delay') return 'Délai en jours';
    if (key === 'payment_effective_at') return 'Paiement validé le';
    if (key === 'payment_effective_by') return 'Paiement validé par';
    if (key === 'payment_expected_date') return 'Date du paiement';
    if (key === 'payment_method') return 'Mode de paiement';
    if (key === 'payment_scheduled_at') return 'Paiement demandé le';
    if (key === 'payment_scheduled_by') return 'Paiement demandé par';
    if (key === 'payment_scheduled_timing') return 'Délai du paiement';
    if (key === 'payment_supplier_rib_id') return 'RIB du fournisseur';
    if (key === 'payment_timing') return 'Délai du paiement';
    if (key === 'payment_transfer_date') return 'Date de virement';
    if (key === 'phone' && alt === 'long') return 'Numéro de tél.';
    if (key === 'phone' && alt === 'short') return 'Téléphone';
    if (key === 'phone_secondary' && alt === 'long') return 'Numéro de tél. secondaire';
    if (key === 'phone_secondary' && alt === 'short') return 'Téléphone secondaire';
    if (key === 'photo_import') return 'Import de Photo';
    if (key === 'picked_up_at') return 'Date de ramassage';
    if (key === 'pink_screen') return 'Dalle rosé';
    if (key === 'poc') return 'Impact écran';
    if (key === 'pocoff') return 'Impact hors zone écran';
    if (key === 'pocon') return 'Impact zone écran';
    if (key === 'postal_code') return 'Code postal';
    if (key === 'price') return 'Montant';
    if (key === 'price_avg' && alt === 'long') return "Prix d'achat";
    if (key === 'price_avg' && alt === 'short') return 'Prix moyen';
    if (key === 'price_avg_max') return 'Prix maximum';
    if (key === 'price_avg_min') return 'Prix minimum';
    if (key === 'print_return_label_date') return 'Date de génération';
    if (key === 'price_rma') return 'NC - Remise / Demandé';
    if (key === 'proc' && alt === 'long') return 'Type de processeur';
    if (key === 'proc' && alt === 'short') return 'Proc ';
    if (key === 'proc') return 'Type de processeur';
    if (key === 'process_handled_by') return 'Technicien';
    if (key === 'processeur') return 'Processeur';
    if (key === 'product_blacklisted') return 'Appareil blockliste';
    if (key === 'product_counterfeit') return 'Contrefacon';
    if (key === 'product_description') return 'Description';
    if (key === 'product_greylisted') return 'Produit greyliste';
    if (key === 'product_name') return 'Produit';
    if (key === 'product_rooted') return 'Appareil roote';
    if (key === 'ps') return 'Procédées Spéciaux';
    if (key === 'purchasable_category') return 'Catégorie de produit';
    if (key === 'purchasable_id') return 'Référence du produit';
    if (key === 'purchasable_type') return 'Type de produit';
    if (key === 'purchase_date') return "Date d'achat";
    if (key === 'purchase_price' && alt === 'long') return "Prix d'achat";
    if (key === 'purchase_price' && alt === 'short') return 'Prix';
    if (key === 'purchase_reference') return 'Référence de liste de départ';
    if (key === 'purchase_status' && alt === 'long') return 'Statut de la commande';
    if (key === 'purchase_types') return 'Type de commande';
    if (key === 'put_battery') return 'Pose batterie';
    if (key === 'put_motherboard') return 'Pose carte mère';
    if (key === 'quality') return 'Qualité';
    if (key === 'quality_defaults') return 'Défaut de qualité';
    if (key === 'quantity' && alt === 'long') return 'Quantité en stock';
    if (key === 'quantity' && alt === 'short') return 'Quantité';
    if (key === 'quantity_already_received') return 'Quantité déjà reçue';
    if (key === 'quantity_def_in_match_stock') return 'Quantité défectueuse en stock à vendre';
    if (key === 'quantity_desired' && alt === 'long') return 'Quantité souhaitée en stock';
    if (key === 'quantity_desired' && alt === 'short') return 'Quantité souhaitée';
    if (key === 'quantity_in_match_stock') return 'Quantité en stock à vendre';
    if (key === 'quantity_max') return 'Quantité maximum';
    if (key === 'quantity_min') return 'Quantité minimum';
    if (key === 'quantity_okamac_max') return 'Quantité Okamac max.';
    if (key === 'quantity_okamac_min') return 'Quantité Okamac min.';
    if (key === 'quantity_ordered') return 'Quantité commandée';
    if (key === 'quantity_query') return 'Quantité souhaitée';
    if (key === 'quantity_query_max') return 'Quantité maximum';
    if (key === 'quantity_query_min') return 'Quantité minimum';
    if (key === 'quantity_received' && alt === 'long') return "Quantité d'ordinateur reçue";
    if (key === 'quantity_received') return 'Quantité reçue';
    if (key === 'quantity_control') return 'Quantité controlé';
    if (key === 'quantity_supplier') return 'Quantité chez le fournisseur';
    if (key === 'quantity_supplier_max') return 'Quantité fournisseur max.';
    if (key === 'quantity_supplier_min') return 'Quantité fournisseur min.';
    if (key === 'quantity_total') return 'Quantité totale';
    if (key === 'querier') return 'Demandeur';
    if (key === 'query_date') return 'Date de la demande';
    if (key === 'ram' && alt === 'long') return 'Mémoire RAM';
    if (key === 'ram' && alt === 'short') return 'RAM';
    if (key === 'ram') return 'Mémoire RAM';
    if (key === 'rate') return 'Taux';
    if (key === 'ratio_ncf') return 'Ratio du prix NC';
    if (key === 'reasons') return 'Raisons';
    if (key === 'reasons_details') return 'Détail des raisons';
    if (key === 'reception_status') return 'Statut de la réception';
    if (key === 'reference_internal') return 'Référence interne';
    if (key === 'reference_supplier') return 'Référence fournisseur';
    if (key === 'remaining_quantity') return 'Nb palettes';
    if (key === 'repair') return 'Réparation';
    if (key === 'repair-cost') return 'MAJ Coût de Réparation';
    if (key === 'reserve_detail') return 'Détail de la réserve';
    if (key === 'reserve_reception') return 'Réserves à réception';
    if (key === 'retina') return 'Rétina';
    if (key === 'return_type') return 'Type de retour';
    if (key === 'from_exchange') return alt === 'short' ? 'Issue échange' : "Commande issue d'un échange";
    if (key === 'right_speaker') return 'Haut parleur droit';
    if (key === 'rma_file') return 'Fichier NC';
    if (key === 'rma_problem_desc') return 'Description du problème';
    if (key === 'rma_problem_type') return 'Problème rencontré';
    if (key === 'rma_solution') return 'Solution demandée';
    if (key === 'rma_status') return 'Statut du NC';
    if (key === 'rma_types') return 'Type de NC';
    if (key === 'role') return 'Rôle';
    if (key === 'same_address') return "Utiliser l'adresse de livraison";
    if (key === 'sav_dispatch_time') return 'Temps SAV';
    if (key === 'scratches') return 'Éraflures';
    if (key === 'screen') return 'Écran';
    if (key === 'extract_screen') return 'Extraction écran';
    if (key === 'ps_screen') return 'Écran (PS)';
    if (key === 'ps_extract_screen') return 'Extraction écran (PS)';
    if (key === 'screen_grade') return 'Grade écran';
    if (key === 'screen_spots') return 'Tache écran';
    if (key === 'ps_seal') return 'Joint';
    if (key === 'selling_strat') return 'Stratégie de vente';
    if (key === 'sellable') return 'Stock Vendable';
    if (key === 'serial_no' && alt === 'long') return 'Numéro de série';
    if (key === 'serial_no' && alt === 'short') return 'N° série';
    if (key === 'serial_number') return 'Numéro de série';
    if (key === 'shipping_carrier') return 'Transporteur';
    if (key === 'shipping_company') return 'Transporteur';
    if (key === 'shipping_confirmed_date') return 'Date de livraison confirmée';
    if (key === 'shipping_cost') return 'Coût du transport';
    if (key === 'shipping_date' && alt === 'long') return "Date d'expédition";
    if (key === 'shipping_date' && alt === 'short') return "Date d'exp.";
    if (key === 'shipping_fees') return "Frais d'expédition";
    if (key === 'shipping_time' && alt === 'long') return "Délai d'expédition";
    if (key === 'shipping_time' && alt === 'short') return "Délai d'expédition";
    if (key === 'shipping_tracking_number') return 'N° de suivi colis';
    if (key === 'shipping_type') return 'Type de livraison';
    if (key === 'shippy_name') return 'Nom shippy';
    if (key === 'size' && alt === 'long') return "Taille d'écran";
    if (key === 'size' && alt === 'short') return 'Écran';
    if (key === 'size') return "Taille d'écran";
    if (key === 'sku') return 'SKU Okamac';
    if (key === 'sku-difference-cost') return 'MAJ Algo Association';
    if (key === 'sku_begin_with') return 'Sku commence par';
    if (key === 'sku_marketplace' && alt === 'long') return 'SKU Place de marché';
    if (key === 'sku_marketplace' && alt === 'short') return 'SKU PDM';
    if (key === 'sku_okamac') return 'SKU Okamac';
    if (key === 'sku_part') return 'SKU de piece';
    if (key === 'small_failures') return 'Petites pannes';
    if (key === 'sound_card') return 'Carte son';
    if (key === 'source_marketplace_order_id' && alt === 'long') return 'Numéro de commande initiale';
    if (key === 'source_marketplace_order_id' && alt === 'short') return 'Cmd initiale';
    if (key === 'spare_types') return 'Types de pièces';
    if (key === 'spares_mix') return 'Pièces détachées';
    if (key === 'speaker') return 'Haut parleurs';
    if (key === 'speaker_right') return 'Haut parleur droit';
    if (key === 'speaker_left') return 'Haut parleur gauche';
    if (key === 'ssd') return 'SSD';
    if (key === 'state') return 'État de la cage';
    if (key === 'status' && alt === 'long') return 'Choix du statut';
    if (key === 'status' && alt === 'short') return 'Statut';
    if (key === 'status_required') return 'Choix du statut (Obligatoire)';
    if (key === 'no_stock') return 'Aucun stock';
    if (key === 'waiting_delivery') return 'En attente de livraison';
    if (key === 'to_do') return 'A faire';
    if (key === 'finished') return 'Terminée';
    if (key === 'repaired') return 'Reparée';
    if (key === 'out_stock') return 'Rupture de stock';
    if (key === 'stock_7_days') return 'Stock sous 7 jours';
    if (key === 'in_stock') return 'En stock';
    if (key === 'stikers') return 'Stickers';
    if (key === 'visibility_edge_stikers') return 'Sticker à la limite du visible';
    if (key === 'sticker_case') return 'Sticker coque';
    if (key === 'sticker_topcase') return 'Sticker chassis';
    if (key === 'stock' && alt === 'long') return 'Déplacer vers le stock';
    if (key === 'stock' && alt === 'short') return 'Stock';
    if (key === 'stock_status_id' && alt === 'long') return 'Stock / Statut';
    if (key === 'street_1') return 'N° et libellé de rue';
    if (key === 'street_2') return "Complément d'adresse";
    if (key === 'stripes') return 'Rayures';
    if (key === 'sub_categories') return 'Sous catégories';
    if (key === 'sub_category') return 'Sous catégorie';
    if (key === 'supplier' && alt === 'long') return 'Fournisseur';
    if (key === 'supplier_comment') return 'Commentaire fournisseur';
    if (key === 'supplier_grade') return 'Grade fournisseur';
    if (key === 'supplier_grade_default') return 'Grade fournisseur par défault';
    if (key === 'supplier_grade_name') return 'Nom du grade';
    if (key === 'supplier_grade_parent') return 'Grade liée';
    if (key === 'supplier_id') return 'Fournisseur';
    if (key === 'buyback_date') return 'Date de rachat';
    if (key === 'supplier_reference') return 'Ref. fournisseur';
    if (key === 'swap_screen_todo') return 'Swap écran à faire';
    if (key === 'system') return 'Système';
    if (key === 'usb') return 'USB';
    if (key === 'usb_c') return 'USB-C';
    if (key === 'taille') return 'Taille';
    if (key === 'tax_scheme' && alt === 'long') return 'Régime de taxe';
    if (key === 'tax_scheme' && alt === 'short') return 'Taxe';
    if (key === 'tax_schemes' && alt === 'long') return 'Régimes de taxe';
    if (key === 'tax_type') return 'Régime';
    if (key === 'total_price') return 'Montant total';
    if (key === 'touchbar') return 'Touchbar';
    if (key === 'traces') return 'Traces';
    if (key === 'trackpad_card') return 'Carte trackpad';
    if (key === 'twisted') return 'Chassis tordue';
    if (key === 'unique_purchase') return 'Liste unique';
    if (key === 'unsellable') return 'Invendable';
    if (key === 'unsellable_device') return "Défaut majeur rendant l'appareil invendable";
    if (key === 'unsellable_stikers') return 'Sticker invendable';
    if (key === 'updated_at') return 'Dernière modification';
    if (key === 'upgrade_amount') return "Montant de l'upgrade";
    if (key === 'validated_at') return 'Validée le';
    if (key === 'validated_by') return 'Validée par';
    if (key === 'validated_by_user_name') return 'Validé par';
    if (key === 'vat_number') return 'Numéro de TVA';
    if (key === 'warranty') return 'Garantie';
    if (key === 'warranty_date') return 'Garantie restante';
    if (key === 'warranty_amount') return 'Montant de garantie';
    if (key === 'wifi') return 'Wifi';
    if (key === 'year') return 'Année';
    if (key === 'hdtype') return 'Type du disque dur';
    if (key === 'model_code') return 'Model';
    if (key === 'proc') return 'Type de processeur';
    if (key === 'size') return "Taille d'écran";
    if (key === 'keyboard') return 'Langue du clavier';
    if (key === 'start_date') return 'Date de début';
    if (key === 'ordered_os') return 'Os commandé';
    if (key === 'date_reception') return 'Réceptionné le';
    if (key === 'sku-difference-cost') return 'MAJ Algo Association';
    if (key === 'repair-cost') return 'MAJ Coût de Réparation';
    if (key === 'visibility_edge_stripes') return 'Rayures à la limite du visible';
    if (key === 'stripes') return 'Rayures';
    if (key === 'light_stripes') return 'Rayures légères';
    if (key === 'deep_stripes') return 'Rayures profondes';
    if (key === 'scratches') return 'Éraflures';
    if (key === 'visibility_edge_scratches') return 'Éraflures à la limite du visible';
    if (key === 'light_scratches') return 'Éraflures légères';
    if (key === 'deep_scratches') return 'Éraflures profondes';
    if (key === 'pocon') return 'Impact zone écran';
    if (key === 'pocoff') return 'Impact hors zone écran';
    if (key === 'poc') return 'Impact';
    if (key === 'visibility_edge_poc') return 'POC à la limite du visible';
    if (key === 'light_poc') return 'POC léger';
    if (key === 'deep_poc') return 'POC sévère';
    if (key === 'blue_spots') return 'Tâches bleu';
    if (key === 'yellow_spots_new') return 'Tâches jaune';
    if (key === 'pink_screen') return 'Dalle rosé';
    if (key === 'light_leakage') return 'Fuite de lumière';
    if (key === 'white_spots') return 'WhiteSpot';
    if (key === 'liquid_spots') return 'Tâche liquide';
    if (key === 'dust_screen') return 'Poussière écran';
    if (key === 'MacBookcase') return 'Coque';
    if (key === 'MacBookscreen') return 'Vitre / Dalle';
    if (key === 'MacBooktopcase') return 'Chassis';
    if (key === 'iMaccase') return 'Chassis';
    if (key === 'iMacscreen') return 'Vitre / Dalle';
    if (key === 'iMactopcase') return 'Pied';
    if (key === 'Mactopcase') return 'Boitier metal';
    if (key === 'supplier_grade_name') return 'Nom du grade';
    if (key === 'discoloration') return 'Décoloration';
    if (key === 'broken') return 'Écran cassée / fêlée';
    if (key === 'veils') return 'Voilé';
    if (key === 'traces') return 'Traces';
    if (key === 'stikers') return 'Stickers';
    if (key === 'seal') return 'Joint dégradé';
    if (key === 'light_seal') return 'Joint dégradé léger';
    if (key === 'middle_seal') return 'Joint dégradé moyen';
    if (key === 'deep_seal') return 'Joint dégradé sévère';
    if (key === 'unsellable_seal') return 'Joint dégradé invendable';
    if (key === 'paint') return 'Peinture';
    if (key === 'color_spots') return 'Tâche écran (Bleu / Rose / Jaune / Sombre)';
    if (key === 'white_dark_spots') return 'Whitespot / darkspot';
    if (key === 'dead_pixel') return 'Pixel(s) mort(s)';
    if (key === 'foot') return 'Pied tordu';
    if (key === 'light') return 'Léger';
    if (key === 'middle') return 'Moyen';
    if (key === 'deep') return 'Sévère';
    if (key === 'visibility_edge') return 'Limite du visible';
    if (key === 'visibility_edge_default') return 'Défaut à la limite du visible';
    if (key === 'visible') return 'Voyant';
    if (key === 'unsellable') return 'Invendable';
    if (key === 'degraded') return 'Leger';
    if (key === 'engraving') return 'Gravure';
    if (key === 'unsellable_stikers') return 'Sticker invendable';
    if (key === 'visible_stikers') return 'Sticker voyant';
    if (key === 'label-update-status') return "Template de relocalisation d'ordinateur de masse";
    if (key === 'sku_begin_with') return 'Sku commence par';
    if (key === 'rate') return 'Taux';
    if (key === 'fixed_amount') return 'Montant fixe';
    if (key === 'accessory_problems') return 'Problèmes chargeurs';
    if (key === 'alias_rules') return "Règles d'aliassage";
    if (key === 'sav_dispatch_time') return 'Temps SAV';
    if (key === 'is_mirakl') return 'Est une Mirakl ?';
    if (key === 'selling_strat') return 'Stratégie de vente';
    if (key === 'from_shippy') return 'Utilise shippy ?';
    if (key === 'shippy_name') return 'Nom shippy';
    if (key === 'quality_defaults') return 'Défaut de qualité';
    if (key === 'swap_screen_todo') return 'Swap écran à faire';
    if (key === 'serial_number') return 'Numéro de série';
    if (key === 'modeles') return 'Modèles';
    if (key === 'compatibility_ecran') return 'Compatibilty';
    if (key === 'taille') return 'Taille';
    if (key === 'trackpad') return 'Trackpad';
    if (key === 'processeur') return 'Processeur';
    if (key === 'annee_modele') return 'Année-modèle';
    if (key === 'part_type') return 'Type de pièce';
    if (key === 'created') return 'Date du pricing';
    if (key === 'filess') return 'Nom du fichier';
    if (key === 'files_type') return 'Type de fichier';
    if (key === 'created_at' && alt === 'long') return 'Date de chargement';
    if (key === 'nb_expected_packaging') return 'Nb palettes Total';
    if (key === 'remaining_quantity') return 'Nb palettes';
    if (key === 'nb_received_packaging' && alt === 'short') return 'Palettes arrivées';
    if (key === 'nb_received_packaging' && alt === 'long') return 'Quantité de palettes reçu';
    if (key === 'reserve_reception') return 'Réserves à réception';
    if (key === 'supplier_grade') return 'Grade fournisseur';
    if (key === 'supplier_comment') return 'Commentaire fournisseur';
    if (key === 'supplier_order') return 'Numéro de commande fournisseur';
    if (key === 'supplier_order') return 'Numéro de commande fournisseur';
    if (key === 'reserve_detail') return 'Détail de la réserve';
    if (key === 'opportunity_name') return "N° d'opportunité";
    if (key === 'marketplace_buyback') return 'Marcketplace de rachat';
    if (key === 'purchase_types') return 'Type de commande';
    if (key === 'date') return 'Date';
    if (key === 'reasons_details') return 'Détail des raisons';
    if (key === 'deep_default') return 'Défaut sévère';
    if (key === 'visibility_edge_default_front') return 'Défaut à la limite du visible - face avant';
    if (key === 'light_default_front') return 'Défaut léger - face avant';
    if (key === 'deep_default_front') return 'Défaut sévère - face avant';
    if (key === 'light_default') return 'Défaut léger';
    if (key === 'visibility_edge_default') return 'Défaut à la limite du visible';
    if (key === 'visibility_edge_default_inner') return 'Défaut à la limite du visible - zone écran';
    if (key === 'visibility_edge_default_outer') return 'Défaut à la limite du visible - hors zone écran';
    if (key === 'supplier_grade_parent') return 'Grade liée';
    if (key === 'purchase_reference') return "N° d'opportunité de départ";
    if (key === 'unique_purchase') return 'Liste unique';
    if (key === 'marketplace_grade') return 'Grade marketplace';
    if (key === 'topcase' || key === 'ps_topcase') return 'Chassis';
    if (key === 'topcase_grade') return 'Grade chassis';
    if (key === 'visibility_edge_default_off') return 'Défauts à la limite du visible - Hors écran';
    if (key === 'visibility_edge_default_on') return 'Défauts à la limite du visible - Sur écran';
    if (key === 'visibility_edge_poc') return 'POC à la limite du visible';
    if (key === 'visibility_edge_scratches') return 'Éraflures à la limite du visible';
    if (key === 'visibility_edge_stripes') return 'Rayures à la limite du visible';
    if (key === 'visible') return 'Voyant';
    if (key === 'visible_default_off') return 'Défauts sévères - Hors écran';
    if (key === 'visible_default_on') return 'Défauts sévères - Sur écran';
    if (key === 'visible_stikers') return 'Sticker voyant';
    if (key === 'warranty') return 'Garantie';
    if (key === 'warranty_amount') return 'Montant de garantie';
    if (key === 'warranty_date') return 'Garantie restante';
    if (key === 'warranty_types') return 'Type de garantie';
    if (key === 'webcam') return 'Webcam';
    if (key === 'year') return 'Année';
    if (key === 'yellow_spots_new') return 'Tâches jaune';
    if (key === 'broken_apple') return 'Pomme cassée';
    if (key === 'apple') return 'Pomme cassée';
    if (key === 'veils') return 'Voilé';
    if (key === 'light_veils') return 'Voilé à la limite du visible';
    if (key === 'visible_veils') return 'Voilé léger';
    if (key === 'deep_veils') return 'Voilé sévère';
    if (key === 'unsellable_veils') return 'Voilé invendable';
    if (key === 'ecid') return 'DFU';
    if (key === 'nanotextured') return 'Nanotexturé';
    if (key === 'invoice_file_id') return 'Numéro de pièce';
    if (key === 'invoice_type') return 'Type de pièce';
    if (key === 'sale_type') return 'Type de vente';
    if (key === 'total_ht') return 'Total HT';
    if (key === 'total_ttc') return 'Total TTC';
    if (key === 'tax_rate') return 'Taux de taxe';
    if (key === 'country_tax') return 'Pays de taxation';
    if (key === 'filter_defect') return 'Défaut filtre Invendable';
    if (key === 'touches') return 'Traces touches';
    if (key === 'invendable') return 'Invendable';
    /* Codes de tâches de réparation (Task#parts_code) sans autre entrée dans ce dico */
    if (key === 'no_parts') return 'Sans pièce détachée';
    if (key === 'ps_foot') return 'Pied (esthétique)';
    if (key === 'put_screen') return 'Pose écran';
    if (key === 'welding') return 'Soudure';
    if (key === 'angle_sensor') return 'Capteur angle écran';
    if (key === 'backlight') return 'Rétroéclairage';
    if (key === 'disable') return 'Désactivation';
    if (key === 'key') return 'Touche';
    if (key === 'micro') return 'Micro';
    // if (process.env.NODE_ENV !== 'production') throw new Error(`Unknown key ${key}/${alt} in DicoLabelsService`);
    return key;
  }

  decodeYearCode(value: string): string {
    if (!value) return;
    const [firstChar, ...year] = value.split('');
    switch (firstChar) {
      case 'E':
        return `Early 20${year.join('')}`;
      case 'M':
        return `Mid. 20${year.join('')}`;
      case 'L':
        return `Late 20${year.join('')}`;
      default:
        return `20${year.join('')}`;
    }
  }

  decodeYearOnly(value: string): string {
    if (!value) return;
    return `20${value.slice(1, 3)}`;
  }

  decodeColor(value: string, label: string): string {
    if (!value) return;
    switch (value) {
      case '0A':
        return '<i class="fas fa-circle" style="color:#e5e7ea"></i> ' + label;
      case '0B':
        return '<i class="far fa-circle"></i> ' + label;
      case 'BL':
        return '<i class="fas fa-circle" style="color:#25486a"></i> ' + label;
      case '0G':
        return '<i class="fas fa-circle" style="color:#a9a8ac"></i> ' + label;
      case '0J':
        return '<i class="fas fa-circle" style="color:#e88b1c"></i> ' + label;
      case '0N':
        return '<i class="fas fa-circle" style="color:#333"></i> ' + label;
      case '0O':
        return '<i class="fas fa-circle" style="color:#f3e2cb"></i> ' + label;
      case 'OR':
        return '<i class="fas fa-circle" style="color:#e76840"></i> ' + label;
      case '0R':
        return '<i class="fas fa-circle" style="color:#fcdad6"></i> ' + label;
      case 'Ro':
        return '<i class="fas fa-circle" style="color:#b72d31"></i> ' + label;
      case 'RO':
        return '<i class="fas fa-circle" style="color:#b72b2c"></i> ' + label;
      case '0V':
        return '<i class="fas fa-circle" style="color:#14505b"></i> ' + label;
      case 'VI':
        return '<i class="fas fa-circle" style="color:#343c70"></i> ' + label;
      case 'MN':
        return '<i class="fas fa-circle" style="color:#2E3641"></i> ' + label;
      case 'LS':
        return '<i class="fas fa-circle" style="color:#F0E5D3"></i> ' + label;
      case 'NS':
        return '<i class="fas fa-circle" style="color:#2E2C2F"></i> ' + label;
      case 'BC':
        return '<i class="fas fa-circle" style="color:#87CEEB"></i> ' + label;
      case 'RP':
        return '<i class="fas fa-circle" style="color:#e8d4d3"></i> ' + label;
      case 'JA':
        return '<i class="fas fa-circle" style="color:#dedc8c"></i> ' + label;
      case 'IN':
        return '<i class="fas fa-circle" style="color:#616f87"></i> ' + label;
      default:
        return value;
    }
  }

  decodeFlag(value: string) {
    if (!value || value == 'AA') return;
    return (
      '<img src="/img/flags/' +
      value +
      '.png" style="width:1rem;height:1rem;margin-right:0.5rem;border-radius:1rem"></img>'
    );
  }

  decodeDeviceType(value: string): string {
    if (!value) return;
    switch (value) {
      case 'laptop':
        return 'Ordinateur portable';
      case 'desktop':
        return 'Ordinateur fixe';
      default:
        return value;
    }
  }

  decodeLocationType(value: string): string {
    if (!value) return;
    switch (value) {
      case 'stock':
        return 'Stock';
      case 'cart':
        return 'Chariot';
      case 'sav':
        return 'SAV';
      case 'preparation':
        return 'Préparation';
      case 'ri':
        return 'Réparation interne';
      case 'shipping':
        return 'Expédition';
      default:
        return value;
    }
  }

  decodeCompanyRole(value: UserCompanyRole): string {
    if (!value) return;
    switch (value) {
      case UserCompanyRole.ADMIN:
        return '<i class="fas fa-user-lock"></i> Administrateur';
      case UserCompanyRole.DIRECTION:
        return '<i class="fas fa-user"></i> Direction';
      case UserCompanyRole.TECHNICIEN:
        return '<i class="fas fa-user"></i> Technicien';
      default:
        return '-';
    }
  }

  decodeAppSubSection = (value: string): string => {
    if (!value) return;
    if (value === 'cleaning') return "Nettoyage de l'ordinateur";
    if (value === 'conformity') return 'Contrôle conformité';
    if (value === 'os') return "Installation de l'OS";
    if (value === 'packaging') return 'Emballage';
    if (value === 'parts') return 'Changement des pièces';
  };

  formatName(user: { first_name?: string; last_name?: string } = {}): string {
    const { first_name, last_name } = user;
    return (
      '' +
      (first_name ? capitalize(first_name) : '') +
      (last_name ? (first_name ? ' ' : '') + last_name.toUpperCase() : '') +
      (!first_name && !last_name ? 'Inconnu' : '')
    );
  }

  formatAmount(amont, currencies, currency): string {
    if (amont === null) return '-';

    const currency_label = (currencies || {})[currency] || '-';
    return `${amont} ${currency_label}`;
  }

  formatItemDesc(
    item: Device | Accessory | Battery | Charger | Consumable | HardDrive | Ram | undefined,
    settings: GlobalSettings
  ): string {
    if (!item || !settings) return '-';
    if ('desc' in item) return item.desc;
    if (item.sku) return this.formatItemDescOtherDevice(item, settings);

    const desc = [];
    desc.push('year' in item ? Object.fromEntries(settings.years)[item.year].display_name : '-');
    desc.push('proc' in item ? Object.fromEntries(settings.procs)[item.proc] : '-');
    desc.push('freq' in item ? `${item.freq} ${this.getUnit('frequency')}` : '-');
    desc.push('graphic_card' in item ? Object.fromEntries(settings.graphic_cards)[item.graphic_card] : '-');
    desc.push('hdsize' in item ? `${item.hdsize} ${this.getUnit('capacity')}` : '-');
    desc.push('hdtype' in item ? Object.fromEntries(settings.drives)[item.hdtype] : '-');
    desc.push('ram' in item ? `${item.ram} ${this.getUnit('capacity')}` : '-');
    desc.push('color' in item ? Object.fromEntries(settings.colors)[item.color] : '-');
    desc.push('grade' in item ? Object.fromEntries(settings.grades)[item.grade] : '-');
    return desc.join(' / ');
  }

  formatItemDescOtherDevice(item, settings): string {
    if (item.sku.slice(0, 2) == 'AW') return this.formatItemDescAppleWatch(item, settings);
    return item.sku;
  }

  formatItemDescAppleWatch(item, settings): string {
    const desc = [];
    settings.apple_watch.forEach(value => {
      switch (Object.keys(value)[0]) {
        case 'series':
          desc.push(value['series'][item.sku.slice(2, 5)]);
          break;
        case 'years':
          desc.push(value['years'][item.sku.slice(5, 8)]);
          break;
        case 'size':
          desc.push(value['size'][item.sku.slice(10, 13)]);
          break;
        case 'materials':
          desc.push(value['materials'][item.sku.slice(13, 16)]);
          break;
        case 'color_screens':
          desc.push(value['color_screens'][item.sku.slice(16, 18)]);
          break;
        case 'size_bracelet':
          desc.push(value['size_bracelet'][item.sku.slice(20, 22)]);
          break;
        case 'type_bracelet':
          desc.push(value['type_bracelet'][item.sku.slice(22, 25)]);
          break;
        case 'color_bracelet':
          desc.push(value['color_bracelet'][item.sku.slice(25, 27)]);
          break;
        case 'technology':
          desc.push(value['technology'][item.sku.slice(29, 31)]);
          break;
      }
    });
    return desc.length > 0 ? desc.join(' / ') : item.sku;
  }

  formatPurchaseItemShare(items: PurchaseItem[], key: keyof PurchaseItem, labels?: string[][]) {
    const dicoLabels = labels
      ? labels.reduce((prev, curr) => {
          prev[curr[0]] = curr[1];
          return prev;
        }, {})
      : {};
    const values = items.reduce(
      (prev, curr) => {
        prev[curr[key]] = (prev[curr[key]] || 0) + 1;
        prev.total += 1;
        return prev;
      },
      { total: 0 } as Record<string | number, number>
    );
    return Object.keys(values)
      .filter(key => key !== 'total')
      .sort((a, b) => values[b] - values[a])
      .map(e => {
        if (['model', 'consumable_type', 'spare_type'].indexOf(key) >= 0) {
          return `${dicoLabels[e] || e} (${values[e]})`;
        } else {
          return `${dicoLabels[e] || e} (${Math.round((values[e] / values['total']) * 100)} %)`;
        }
      })
      .join(', ');
  }

  getUnit(key: string): string {
    switch (key) {
      case 'capacity':
        return 'Go';
      case 'day':
        return 'jours';
      case 'frequency':
        return 'GHz';
      case 'intensity':
        return 'mAh';
      case 'money':
        return '€';
      case 'month':
        return 'mois';
      case 'percentage':
        return '%';
      case 'screen_size':
        return '"';
      case 'number_cores':
        return '';
      default:
        return 'missing_key';
    }
  }
}

export const dicoLabelsService = new DicoLabelsService();
